import type { FC } from "react";
import { FormComponent, RouteComponent } from "./components";
import { RoutesPageContainer, Text } from "./route-management-page.styles";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getKeyWordsForm } from "@src/core/utils";
import { Back, FormWrapper } from "@src/core/styles";
import { FormContainer } from "./components/form-component/form-components.styles";
import { RoutePageTitle } from "./components/form-component/form-components.styles";
import { ReactComponent as Arrow } from "@src/core/icons/arrow.svg";
import { APP_ROUTES } from "@src/core/constants";

export const RouteManagementPage: FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { formMethod } = getKeyWordsForm(pathname);

  const { workspaceId } = useParams();

  const backHandler = () => {
    navigate(`${APP_ROUTES.PRICE}`);
  };

  return (
    <RoutesPageContainer>
      <RouteComponent />

      {!workspaceId && !formMethod ? (
        <FormContainer>
          <FormWrapper>
            {!formMethod && (
              <Back onClick={backHandler}>
                <Arrow />
              </Back>
            )}
            <RoutePageTitle>Введение</RoutePageTitle>
            <Text>
              <div>
                Вы можете создать своё собственное пространство в LightBoxAPI
                или использовать функцию автоматического построения API, которая
                поможет вам быстро создать ваше API.
              </div>
              <div>
                Если у вас возникнут вопросы или у вас есть предложения по
                улучшению сервиса, вы можете обратиться к разделам{" "}
                <Link to="/offers">«Вопросы по работе сервиса»</Link> и{" "}
                <Link to="/offer">«Предложения по улучшению»</Link>. Ваш отзыв очень
                важен для нас, и мы всегда готовы помочь вам в решении всех
                вопросов.
              </div>
            </Text>
          </FormWrapper>
        </FormContainer>
      ) : (
        <FormComponent pathname={pathname} />
      )}
    </RoutesPageContainer>
  );
};
